import { render, staticRenderFns } from "./TabIdeacion.vue?vue&type=template&id=6a7ba9d3&scoped=true&"
import script from "./TabIdeacion.vue?vue&type=script&lang=js&"
export * from "./TabIdeacion.vue?vue&type=script&lang=js&"
import style0 from "./TabIdeacion.vue?vue&type=style&index=0&id=6a7ba9d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7ba9d3",
  null
  
)

export default component.exports